export default __webpack_public_path__ + "static/media/bronze_medal.a6118719.png";